<template>
    <div
        tabindex="0"
        role="button"
        class="relative flex flex-col items-center lg:hidden"
        :aria-label="$t('layout.header.actions.search')"
        aria-haspopup="true"
        :aria-expanded="sidenav.isOpen('search').value"
        @click="sidenav.toggle('search')"
        @keydown.enter.prevent="sidenav.toggle('search')"
    >
        <div class="btn btn-circle btn-ghost">
            <MiscIcon name="search" />
        </div>

        <span class="text-xs hidden lg:inline-block">{{ $t('layout.header.actions.search') }}</span>
    </div>

    <client-only>
        <CustomerState :in-drawer="inDrawer" />

        <template #fallback>
            <div class="relative flex flex-col items-center">
                <div class="btn btn-circle btn-ghost">
                    <MiscIcon name="user" />
                </div>
                <span class="hidden text-xs lg:inline-block" :aria-label="$t('layout.header.actions.logIn')">{{ $t('layout.header.actions.logIn') }}</span>
            </div>
        </template>
    </client-only>

    <MiscLink
        to="/wishlist"
        tabindex="0"
        data-cy="wishlistLink"
        class="relative flex flex-col items-center"
        :aria-label="$t('layout.header.actions.wishlist')"
    >
        <div class="btn btn-circle btn-ghost">
            <div class="indicator">
                <MiscIcon name="heart" />
                <client-only>
                    <span v-if="wishlistCount > 0" class="badge badge-sm indicator-item border-none lg:badge-primary" v-text="wishlistCount" />
                </client-only>
            </div>
        </div>
        <span class="hidden text-xs lg:inline-block">{{ $t('layout.header.actions.wishlist') }}</span>
    </MiscLink>

    <MiscLink
        to="/cart"
        tabindex="0"
        class="relative flex flex-col items-center"
        data-cy="cartLink"
        :aria-label="$t('layout.header.actions.cart')"
    >
        <div class="btn btn-circle btn-ghost">
            <div class="indicator">
                <MiscIcon name="shopping-cart" />
                <client-only>
                    <span v-if="cartItemCount > 0" class="badge badge-sm indicator-item border-none lg:badge-primary" v-text="cartItemCount" />
                </client-only>
            </div>
        </div>

        <span class="hidden text-xs lg:inline-block">{{ $t('layout.header.actions.cart') }}</span>
    </MiscLink>
</template>

<script setup lang="ts">
import { useCart, useWishlist } from '#imports'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
    inDrawer?: boolean
}>()

const sidenav = useSidenav()

const { cart } = useCart()
const cartItemCount = computed(() => cart.value?.lineItems?.length ?? 0)

const { count: wishlistCount } = useWishlist()
</script>
